import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { ProcessService } from 'app/core/process/process.service';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModalModule } from 'app/modal/modal.module';
import { ProcessCategoriesRoutingModule } from 'app/processCategories/processCategories-routing.module';
import { ProcessCategoriesComponent } from 'app/processCategories/processCategories.component';

@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    ModalModule,
    ProcessCategoriesRoutingModule
  ],
  declarations: [
    ProcessCategoriesComponent
  ],
  providers: [
    ProcessService
  ]
})
export class ProcessCategoriesModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/processCategories/processCategories.module.ts